import { useStateValue } from "../../context/StateProvider";
import { motion } from "framer-motion";
import { addToCart } from "../../utils/functions";
import { MdAddShoppingCart } from "react-icons/md"; 
import { FoodItem } from "../../../types";
import { useEffect, useState } from "react";
const Action = ({ food, admin }: { food: FoodItem; admin?: boolean }) => {
  const [{ cartItems, foodItems }, dispatch] = useStateValue();

  const [inCart, setInCart] = useState(false);

  useEffect(() => {
    const isItem = cartItems?.find((item: { fid: any; }) => item?.fid === food?.id);
    setInCart(!!isItem);
  }, [cartItems, food?.id])

  return (
    <div className="flex flex-col gap-2">
      <motion.div
        whileTap={{ scale: 1.1 }}
        whileHover={{ scale: 1.2 }}
        className={`w-8 h-8 md:w-10 md:h-10 rounded-full ${food.comingSoon || !food.isActive
            ? " cursor-not-allowed"
            : inCart ? "bg-slate-700 cursor-not-allowed" : "bg-redPrimary cursor-pointer"
          } flex items-center justify-center`}
        onClick={() =>
          !(food.comingSoon || !food.isActive) &&
          addToCart(cartItems, foodItems, food.id, dispatch)
        }
        title={
          food.comingSoon ? "Coming Soon" : !food.isActive ? "Not Available" : "Add to cart"
        }
      >
        {/* <MdAddShoppingCart className="text-white md:text-xl" /> */}
        {food.comingSoon ?
          (<h1 className="bg-orange-400 mr-10 text-white text-xs rounded-xl p-1">Coming Soon</h1>)
          :
          !food.isActive ?
            (<h1 className="bg-slate-600 mr-10 text-white text-xs rounded-xl p-1">Not Available</h1>)
            :
            <MdAddShoppingCart className="text-white md:text-xl" />
        }
      </motion.div>
    </div>
  );
};
 


export default Action;
